var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseTitle',{attrs:{"schedule":_vm.schedule,"metadata-items":_vm.metadataList},scopedSlots:_vm._u([{key:"infoIcon",fn:function(ref){
var metadata = ref.metadata;
return [_c('more-info',{attrs:{"show-info-icons":metadata.showInfoIcons,"show-learn-more":false,"labels":_vm.moreInfoModalLabels,"abbr-content":_vm.feeScheduleTooltipContent,"detailed-content":_vm.feeScheduleTooltipContent}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }